import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { timerComponent } from '../cheque-book-request/timerComponent';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
declare var getHexAscii: any;
@Component({
  selector: 'app-loan-disburse-details',
  templateUrl: './loan-disburse-details.component.html',
  styleUrls: ['./loan-disburse-details.component.css']
})
export class LoanDisburseDetailsComponent implements OnInit {
	loanAccounts : any = [];
	 accountNull:string="yes";
	 loanAcc:string='';
   show:string='page1';
  
   authStatus:String;
   map:any[];
   listOfMap:any[];
   public filterQuery = '';
    public rowsOnPage = 5;
    public sortBy = 'particulars';
    public sortOrder = 'asc';
  public data:any=[]

  constructor(private webService: CallBackEndService,
    private timetStart : timerComponent,private spinnerService: Ng4LoadingSpinnerService,) { 
    this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
    //this.loanAcc = JSON.parse(sessionStorage.getItem('loanAccounts'));
  }

  ngOnInit() {
  }
  removestacctMessage()
  {
    this.accountNull='';
  }
  validateAccNo()
  {
   if (this.loanAcc === '' || this.loanAcc=== ' ' || this.loanAcc === undefined || this.loanAcc=== null) {
      this.accountNull = 'no';
     
      console.log('loan Acc: '+this.loanAcc +'accountNull value : '+this.accountNull);
      return false;
    }else{
      console.log('loan Acc: '+this.loanAcc +'accountNull value : '+this.accountNull);
      return true;
    }
  }

  loanDetails()
  {
    // if (this.loanAcc=== '' || this.loanAcc === undefined ||this.loanAcc=== null) {
    //   this.accountNull = 'no';
    // }
    // else
    // {
      if(this.validateAccNo()){
      //alert("in else block ----"+this.loanAcc);
      this.spinnerService.show();
	    const request: IbRequest = new IbRequest();
        let response: IbResponse = new IbResponse();
        request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName')+this.loanAcc );
	    request.param2 =sessionStorage.getItem('storedUserName'); 
      request.param3 =this.loanAcc ;
      console.log("name---"+request.param2+"   accNo.---"+request.param3);
        this.webService.getResponse(request, "loanDisbursement").subscribe((data: IbResponse) => {
          console.log("response received");
          this.spinnerService.hide();
         
        if (data !== null && data.status === 'S200') {
          this.authStatus=data.param1;
          this.data=data.param6;
         // alert("account is --"+ this.authStatus);
          this.map=data.param5;
          this.listOfMap=data.param6;
          for(let entry of this.listOfMap)
          {
            for(const [key1, value1] of Object.entries(entry))
            {
             console.log("data of listOfMap-----key--"+entry.instlmtAmt+"  value---"+ JSON.stringify(entry.disburseAmt));  
            }
          }
          for(const [key1, value1] of Object.entries(this.map))
          {
           console.log("data of  Map-----key--"+key1+"  value---"+ JSON.stringify(value1));  
          }

		  this.show="page2";
	     

    }

  });
}}

}


// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/loan-disburse-details/loan-disburse-details.component.ts